import { render, staticRenderFns } from "./SponsoredRecommendationPremiumVideo.vue?vue&type=template&id=0c56d5d2&scoped=true"
import script from "./SponsoredRecommendationPremiumVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationPremiumVideo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationPremiumVideo.vue?vue&type=style&index=0&id=0c56d5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56d5d2",
  null
  
)

export default component.exports